// src/utils/customerOwnership.js
//
// THE owner fact of a customer (docs/bugs/owner_scoping_by_uid_BUG.md, ticket EDJq0rxs1xougr9dBm6k):
// `system.ownerUids`, the ids of the customer's sales reps. Every reader asks this module, and every query that
// scopes to a rep's customers filters OWNER_UIDS_FIELD by the rep's uid.
//
// `system.owner` (lowercased emails) is the older field. The "Assign New Sales Rep" task still writes it, and the
// updateCustomerOrgOnOwnerChange trigger turns it into ownerUids, but nothing READS a customer's owner from it:
// 311 customers (2026-09-25) carry only ownerUids, and an email changes while a uid does not.
//
// Mirror of functions-shared/utils/customerOwnership.js (same functions, CJS). npm run test:customer-ownership pins
// the parity and guards that nothing reads system.owner.

export const OWNER_UIDS_FIELD = 'system.ownerUids'

/** The customer's reps, as user ids (an empty array when it has none). */
export function customerOwnerUids(customer) {
  const uids = customer && customer.system ? customer.system.ownerUids : null
  return Array.isArray(uids) ? uids.filter(uid => typeof uid === 'string' && uid) : []
}

/** Is this user one of the customer's reps? */
export function isCustomerOwner(customer, uid) {
  return typeof uid === 'string' && !!uid && customerOwnerUids(customer).includes(uid)
}
